module.exports = __webpack_public_path__ + "files/3013c681892df32ee02c50fb5cfcb0bc.png";